import { NavLink, useLocation } from 'react-router-dom'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  LayoutDashboard, Building2, MapPin, Users, Shield, AppWindow, FileText, ChevronLeft, ChevronRight, LogOut, KeyRound, MonitorSmartphone
} from 'lucide-react'
import { useAuth } from '@/hooks/useAuth'
import { authApi } from '@/services/api'

const navItems = [
  { path: '/', icon: LayoutDashboard, labelKey: 'navigation.dashboard' },
  { path: '/empresas', icon: Building2, labelKey: 'navigation.empresas' },
  { path: '/filiais', icon: MapPin, labelKey: 'navigation.filiais' },
  { path: '/usuarios', icon: Users, labelKey: 'navigation.usuarios' },
  { path: '/perfis', icon: Shield, labelKey: 'navigation.perfis' },
  { path: '/aplicacoes', icon: AppWindow, labelKey: 'navigation.aplicacoes' },
  { path: '/funcionalidades', icon: KeyRound, labelKey: 'navigation.funcionalidades' },
  { path: '/sessoes', icon: MonitorSmartphone, labelKey: 'navigation.sessoes' },
  { path: '/auditoria', icon: FileText, labelKey: 'navigation.auditoria' },
]

export default function Sidebar() {
  const [collapsed, setCollapsed] = useState(false)
  const location = useLocation()
  const { t } = useTranslation()
  const { clearAuth } = useAuth()

  const handleLogout = async () => {
    try { await authApi.logout() } finally { clearAuth() }
  }

  return (
    <aside className={`${collapsed ? 'w-16' : 'w-64'} flex flex-col border-r border-slate-800 bg-gradient-to-b from-[#22252a] to-[#0d0f12] text-white transition-all duration-300`}>
      <div className="flex h-20 items-center justify-between border-b border-white/10 px-3">
        {!collapsed && (
          <div className="flex min-w-0 items-center gap-2">
            <img src="https://goldenax.us/assets/goldenax-logo.png?v=20260908-2" alt="GoldenAx" className="h-14 w-20 object-contain" />
            <div className="min-w-0">
              <span className="block truncate text-sm font-extrabold">AccessControl</span>
              <span className="block text-[10px] font-bold uppercase tracking-widest text-primary-300">GoldenAx</span>
            </div>
          </div>
        )}
        <button
          onClick={() => setCollapsed(!collapsed)}
          aria-label={collapsed ? t('navigation.expandMenu') : t('navigation.collapseMenu')}
          className="rounded-md p-1.5 text-slate-300 transition hover:bg-white/10 hover:text-primary-300"
        >
          {collapsed ? <ChevronRight className="h-5 w-5" /> : <ChevronLeft className="h-5 w-5" />}
        </button>
      </div>

      <nav className="flex-1 space-y-1 px-2 py-4">
        {navItems.map((item) => {
          const Icon = item.icon
          const isActive = location.pathname === item.path
          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 rounded-md border-l-2 px-3 py-2.5 transition-all duration-200 ${
                isActive
                  ? 'border-primary-400 bg-primary-500/15 text-primary-300'
                  : 'border-transparent text-slate-400 hover:bg-white/5 hover:text-white'
              }`}
              title={collapsed ? t(item.labelKey) : undefined}
            >
              <Icon className="h-5 w-5 flex-shrink-0" />
              {!collapsed && <span className="text-sm font-semibold">{t(item.labelKey)}</span>}
            </NavLink>
          )
        })}
      </nav>

      <div className="border-t border-white/10 p-2">
        <button
          onClick={handleLogout}
          className="flex w-full items-center gap-3 rounded-md px-3 py-2.5 text-slate-400 transition hover:bg-white/5 hover:text-red-300"
          title={collapsed ? t('auth.logout') : undefined}
        >
          <LogOut className="h-5 w-5 flex-shrink-0" />
          {!collapsed && <span className="text-sm font-semibold">{t('auth.logout')}</span>}
        </button>
      </div>
    </aside>
  )
}
